import { OnRegionChange } from './detector';
import { clearNoteSelection } from '../utils';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

const getAppServices = (): IEditorAppServices => AppServiceProvider.getInstance().getAppServices() as
    IEditorAppServices;

const getSelectionService = () => getAppServices().viewableServiceLayer?.selectionService;

// 参考 src/framework/frame/components/region-wrapper/index.js#L27 > `handleMouseDownCapture `
// 演示态下实际只有 [RegionType.NOTE, RegionType.NONE], 因此精简如下
export const onRegionChange: OnRegionChange = (type) => {
    const { currentSlide } = getSelectionService();
    switch (type) {
        case RegionType.NOTE:
            if (currentSlide) {
                currentSlide.noteData.selected = true;
            }
            break;
        default:
            clearNoteSelection();
            break;
    }
};
